import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ffb192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card capture-container" }
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center mb-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "or-text" }, "OR", -1))
const _hoisted_5 = { class: "ms-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Email me capture link", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-18" }, null, -1))
const _hoisted_8 = { class: "w-100 text-center" }
const _hoisted_9 = {
  key: 1,
  class: "py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_vue_qrcode, { value: $setup.url }, null, 8, ["value"]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control mb-6",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
              }, null, 512), [
                [_vModelText, $setup.email]
              ]),
              _createVNode(_component_Button, {
                class: "w-100",
                label: "Send",
                disabled: $setup.sendingLink,
                onClicked: $setup.sendLink
              }, null, 8, ["disabled", "onClicked"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: "I have completed all captures",
              variant: "success",
              disabled: $props.fetchingCaptures,
              onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-complete')))
            }, null, 8, ["disabled"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_Spinner)
        ]))
  ]))
}